<template>
    <v-autocomplete
        v-if="this.multiple"
        v-model="especialidades"
        variant="solo"
        :items="especialidadesDisponibles"
        :item-title="especialidadTitle"
        item-value="nombre"
        :rules="obligatorio"
        :loading="cargandoEspecialidades"
        label="Especialidades"
        required
        multiple
        chips
        clearable
        class="asterisco"
        @update:model-value="seleccionarEspecialidades"
    >
    </v-autocomplete>
    <v-autocomplete
        v-else
        v-model="especialidadId"
        variant="solo"
        :items="especialidadesDisponibles"
        :item-title="especialidadTitle"
        item-value="id"
        :rules="obligatorio"
        :loading="cargandoEspecialidades"
        label="Especialidad"
        required
        clearable
        class="asterisco"
        @update:model-value="seleccionarEspecialidad"
    >
    </v-autocomplete>
</template>
<style src="../assets/general.css"></style>
<script>
    import { obligatorio } from '@/_helpers/rules';
    import ProfesionalService from '@/api/ProfesionalService';

    const profesionalService = new ProfesionalService();

    export default{
        data() {
            return {
                especialidades: [],
                especialidadId: null,
                especialidadesDisponibles: [],
                obligatorio: obligatorio,
                cargandoEspecialidades: false
            }
        },
        props: {
            multiple: {
                type: Boolean,
                default: true
            }
        },
        mounted() {
            this.cargarEspecialidades();
        },
        methods: {
            async cargarEspecialidades() {
                this.cargandoEspecialidades = true;
                const response = await profesionalService.getEspecialidades();
                if(response && response.status === 200){
                    this.especialidadesDisponibles = response.data;
                }
                this.cargandoEspecialidades = false;
            },
            especialidadTitle(item){
                if (!item) return '';
                return `${item.codigo} - ${item.nombre}`;
            },
            seleccionarEspecialidades(){
                this.$emit('especialidades-seleccionadas', this.especialidades);
            },
            seleccionarEspecialidad(){
                this.$emit('especialidad-seleccionada', this.especialidadId);
            }
        }
    }
</script>